import React from "react";
import { useAppContext } from "apps/portal/Portal/common/AppContext";
import { Modal, Link } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import styles from "./styles.scss";

type Props = {
  show: boolean;
  onHide: () => void;
};

const HelpModal: React.FunctionComponent<Props> = ({ show, onHide }) => {
  const { currentArenaContent } = useAppContext();

  return (
    <Modal
      className={styles.HelpModal__modal}
      show={show}
      onHide={onHide}
      isCentered
      size="small"
      data-cy="help-modal"
    >
      <Modal.Header closeButton>
        <h2 className="h2" data-cy="help-modal-title">
          Need Help?
        </h2>
      </Modal.Header>
      <Modal.Body>
        <h3 className="h3 stacked-bottom-md">
          Have questions about your investments or offerings?
        </h3>
        <p className="text-md stacked-bottom-md" data-cy="help-modal-contact">
          Contact{" "}
          {currentArenaContent?.name ? currentArenaContent.name : "your manager directly"}
        </p>
        {currentArenaContent?.contactEmail && (
          <p className="text-md stacked-bottom-md">
            <Icon type="envelope" className="inline-sm" data-testid="help_email_icon" />
            <a href={`mailto:${currentArenaContent.contactEmail}`} data-cy="help-modal-email">
              {currentArenaContent.contactEmail}
            </a>
          </p>
        )}
        {currentArenaContent?.contactPhone && (
          <p className="text-md stacked-bottom-md">
            <Icon type="phone" className="inline-sm" data-testid="help_phone_icon" />
            <a href={`tel:+1${currentArenaContent.contactPhone}`} data-cy="help-modal-phone">
              {currentArenaContent.contactPhone}
            </a>
          </p>
        )}
        <hr className={styles.HelpModal__divider} />
        <h3 className="h3 stacked-bottom-md">Have technical questions?</h3>
        <p className="stacked-bottom-md">
          Visit the Juniper Square{" "}
          <Link href="https://investor-help.junipersquare.com" isInline shouldOpenInNewTab>
            Help Center
          </Link>
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default HelpModal;
